import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import axiosInstance from "../../instance";


const url = process.env.REACT_APP_API_BASE_URL;

const initialState = {
  glbLoading: false,
  sideMenuCollapsed: false,
  loading: false,
  menuLoading: false,
  menuData: [],

  refetch: false,
  refetchKey: "",
  openKeys: [],
 
};


export const fetchMenu = createAsyncThunk("menuSlice/fetchMenu", async () => {
  const res = await axiosInstance
    .get(`${url}/api/menu`)
    .then((res) => res.data?.data?.result);
  return res;
});

export const globalSlice = createSlice({
  name: "global",
  initialState,
  reducers: {
    handleSideMenuCollapse: (state, action) => {
      state.sideMenuCollapsed = action.payload;
    },
    setRefetchKey: (state, action) => {
      state.refetchKey = action.payload;
    },
    setRefetch: (state) => {
      state.refetch = !state.refetch;
    },
    setOpenKeys: (state, action) => {
      state.openKeys = action.payload;
    },
  
    clearGlobalObj: () => {
      return { ...initialState };
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(fetchMenu.pending, (state) => {
        state.menuLoading = true;
      })
      .addCase(fetchMenu.fulfilled, (state, action) => {
        state.menuLoading = false;
        state.menuData = action.payload;
      })
      .addCase(fetchMenu.rejected, (state) => {
        state.menuLoading = false;
        state.menuData = [];
      });
  },
});

export default globalSlice.reducer;
export const {
  handleSideMenuCollapse,
  setRefetchKey,
  setRefetch,
  setOpenKeys,
  clearGlobalObj,
} = globalSlice.actions;
